var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatbotUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FEC00F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2439_120357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2138 9.85718C11.9069 9.85718 11.6126 9.97909 11.3956 10.1961C11.1786 10.4131 11.0566 10.7074 11.0566 11.0143C11.0566 11.3212 11.1786 11.6155 11.3956 11.8325C11.6126 12.0496 11.9069 12.1715 12.2138 12.1715C12.5207 12.1715 12.815 12.0496 13.032 11.8325C13.249 11.6155 13.3709 11.3212 13.3709 11.0143C13.3709 10.7074 13.249 10.4131 13.032 10.1961C12.815 9.97909 12.5207 9.85718 12.2138 9.85718Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3706 7.54286H12.5992V6H11.8277V7.54286H11.0563C9.82873 7.54286 8.65144 8.03051 7.78341 8.89853C6.91539 9.76656 6.42773 10.9439 6.42773 12.1714C6.42773 13.399 6.91539 14.5763 7.78341 15.4443C8.65144 16.3123 9.82873 16.8 11.0563 16.8H13.3706C13.4709 16.8 13.5709 16.7967 13.6707 16.79L16.7487 17.5599C16.8133 17.5759 16.8809 17.575 16.945 17.5572C17.0091 17.5394 17.0676 17.5054 17.1146 17.4583C17.1617 17.4113 17.1958 17.3528 17.2135 17.2887C17.2313 17.2246 17.2322 17.1569 17.2162 17.0924L16.771 15.3111C17.3813 14.6501 17.7857 13.8255 17.9348 12.9383C18.0838 12.051 17.9711 11.1396 17.6103 10.3154C17.2495 9.49119 16.6564 8.79002 15.9034 8.29762C15.1504 7.80522 14.2703 7.54294 13.3706 7.54286ZM10.2849 11.0143C10.2849 10.5028 10.4881 10.0123 10.8497 9.65058C11.2114 9.2889 11.702 9.08571 12.2134 9.08571C12.7249 9.08571 13.2155 9.2889 13.5772 9.65058C13.9388 10.0123 14.142 10.5028 14.142 11.0143C14.142 11.5258 13.9388 12.0163 13.5772 12.378C13.2155 12.7397 12.7249 12.9429 12.2134 12.9429C11.702 12.9429 11.2114 12.7397 10.8497 12.378C10.4881 12.0163 10.2849 11.5258 10.2849 11.0143ZM12.2134 15.2571C11.4244 15.2585 10.6586 14.9898 10.0434 14.4957L10.5263 13.894C10.9884 14.2643 11.5747 14.4857 12.2134 14.4857C12.8522 14.4857 13.4385 14.2643 13.9006 13.894L14.3835 14.4957C13.7683 14.9898 13.0025 15.2585 12.2134 15.2571Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2439_120357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5714,
    height: 11.5714,
    fill: "white",
    transform: "translate(6.42773 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatbotUser);
export default __webpack_public_path__ + "static/media/AIChatbot-user.2701abe2844719ce5f00602b3d9c43cc.svg";
export { ForwardRef as ReactComponent };